module.exports = __webpack_public_path__ + "static/imgVacancie2-8bb6e0a11366d8a87880ef215a54d9ca.png";